// src/pages/commercial/CommercialDealRoomPage.js
import React, { useEffect, useState } from 'react';
import CommercialLayout from '../../components/commercial/CommercialLayout';
import { useAuth } from '../../contexts/AuthContext';
import pb from '../../lib/pocketbase';
import { useNavigate } from 'react-router-dom';

export default function CommercialDealRoomPage() {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [deals, setDeals] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchDeals() {
            setLoading(true);
            try {
                // Fetch deals that are in Proposal or Negotiation stage
                const res = await pb.collection('deals').getFullList({
                    sort: '-updated',
                    filter: `owner = "${user.id}" && (stage = "proposal" || stage = "negotiation" || status = "draft")`,
                    expand: 'customer_id'
                });
                setDeals(res);
            } catch (err) {
                console.error("Error fetching deals", err);
            } finally {
                setLoading(false);
            }
        }
        fetchDeals();
    }, [user.id]);

    const handleCopyLink = (dealId) => {
        // In a real app, this would be a public route like /proposal/:id with a secure token
        // For demo, we assume a route /room/:dealId exists
        const link = `${window.location.origin}/room/${dealId}`;
        navigator.clipboard.writeText(link);
        alert(`Lien de la Deal Room copié ! \n${link}`);
    };

    return (
        <CommercialLayout title="Deal Rooms">
            <div className="commercial-page-wrapper">
                <style>{`
                .commercial-page-wrapper {
                    --admin-panel: var(--commercial-panel, #fff);
                    --admin-panel-2: var(--commercial-panel-2, #f9fafb);
                    --admin-border: var(--commercial-border, #e2e8f0);
                    --admin-text: var(--commercial-text, #0f172a);
                    --admin-muted: var(--commercial-muted, #64748b);
                    --admin-accent: var(--commercial-accent, #4f46e5);
                }
                .room-grid {
                    display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 24px;
                }
                .room-card {
                    background: var(--admin-panel); border: 1px solid var(--admin-border);
                    border-radius: 16px; padding: 24px;
                    transition: transform 0.2s, box-shadow 0.2s;
                    display: flex; flexDirection: column; gap: 16px;
                }
                .room-card:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 12px 30px -8px rgba(0,0,0,0.1);
                    border-color: var(--admin-accent);
                }
                .room-header {
                    display: flex; align-items: center; gap: 12px;
                }
                .room-icon {
                    width: 48px; height: 48px; border-radius: 12px; background: linear-gradient(135deg, var(--admin-accent), #8b5cf6);
                    color: white; display: grid; place-items: center; font-size: 1.5rem;
                }
                .btn-share {
                    background: var(--admin-panel-2); border: 1px solid var(--admin-border);
                    color: var(--admin-text); padding: 8px 16px; border-radius: 8px; font-weight: 600;
                    cursor: pointer; transition: all 0.2s; display: flex; align-items: center; justify-content: center; gap: 8px;
                }
                .btn-share:hover { background: var(--admin-accent); color: white; border-color: var(--admin-accent); }
                .btn-preview {
                     background: transparent; color: var(--admin-muted); border: none; cursor: pointer; text-decoration: underline; font-size: 0.9rem;
                }
                .status-badge {
                    padding: 4px 10px; border-radius: 99px; font-size: 0.75rem; fontWeight: 700; text-transform: uppercase;
                }
                `}</style>

                <div style={{ marginBottom: 32 }}>
                    <h1 style={{ margin: '0 0 8px 0', fontSize: '1.8rem' }}>Vos Deal Rooms Actives</h1>
                    <p style={{ margin: 0, color: 'var(--admin-muted)' }}>
                        Des espaces clients personnalisés pour vos propositions en cours. Partagez le lien magique pour impressionner vos prospects.
                    </p>
                </div>

                {loading ? (
                    <div style={{ textAlign: 'center', padding: 40 }}>Chargement des rooms...</div>
                ) : deals.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: 60, background: 'var(--admin-panel)', borderRadius: 16, border: '1px dashed var(--admin-border)' }}>
                        <div style={{ fontSize: '3rem', marginBottom: 16 }}>📭</div>
                        <h3>Aucune proposition en cours</h3>
                        <p style={{ color: 'var(--admin-muted)' }}>Créez un deal et passez-le en étape "Proposition" pour activer sa Deal Room.</p>
                        <button className="btn-primary" onClick={() => navigate('/commercial/deals')} style={{ marginTop: 16 }}>+ Créer un Deal</button>
                    </div>
                ) : (
                    <div className="room-grid">
                        {deals.map(deal => (
                            <div key={deal.id} className="room-card">
                                <div className="room-header">
                                    <div className="room-icon">✨</div>
                                    <div>
                                        <div style={{ fontWeight: 700, fontSize: '1.1rem' }}>{deal.title}</div>
                                        <div style={{ fontSize: '0.9rem', color: 'var(--admin-muted)' }}>
                                            {deal.amount ? `${deal.amount}€` : 'Montant à définir'} • {deal.expand?.customer_id?.company || 'Client'}
                                        </div>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', gap: 8 }}>
                                    <span className="status-badge" style={{ background: '#e0e7ff', color: '#4338ca' }}>
                                        {deal.stage || deal.status}
                                    </span>
                                    <span style={{ fontSize: '0.8rem', color: 'var(--admin-muted)', display: 'flex', alignItems: 'center' }}>
                                        Mis à jour le {new Date(deal.updated).toLocaleDateString()}
                                    </span>
                                </div>

                                <div style={{ marginTop: 'auto', display: 'flex', flexDirection: 'column', gap: 8 }}>
                                    <button className="btn-share" onClick={() => handleCopyLink(deal.id)}>
                                        <span>🔗</span> Copier le lien magique
                                    </button>
                                    <button className="btn-preview" onClick={() => window.open(`/room/${deal.id}`, '_blank')}>
                                        Voir l'aperçu client
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </CommercialLayout>
    );
}
